import React, { useState } from 'react';
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from 'use-media';
import { default as CommonUtil, default as commonUtil } from "../../common/commonUtil";
import { TextArea } from '../../components/atoms/textArea';
import { getCourseInfo, getYoyakuKanoTimeInfo } from '../../const';
import messageConst from '../../const/messageConst';
import common from '../../resources/js/common/common';
import { Label } from '../atoms/label';
import { EstheticAndRestaurantCalendarContainer } from '../organisms/esthetic/estheticAndRestaurantCalendarContainer';
import { CheckboxListBoxGold } from './checkboxListBoxGold';
import { LabelInputForm } from './labelInputForm';
import { ModalOptionForm } from './modalOptionForm';
import { PullDownOptionForm } from './pullDownOptionForm';
import { RadioButtonForm } from './radioButtonForm';

export const RestaurantInputList = (props) => {
    const { state,
        flgList,
        restaurantInfo,
        restaurantReserveInfo,
        setRestaurantReserveInfo,
        agreementList,
        relationList,
        serviceCheckInfo,
        userInfoObj,
        allergyInfo,
        vacancyItems,
        onChangeAgreement,
        onChangeCheckBox,
        onChangeReserveFlg,
        onChangeAllergyInfo,
        onChangeRelation,
        onChangeJikantai,
        handleRepresentInfo,
        onClickDoiTitle,
        onClickServiceLink,
        onClickOpenPopupWindow,
        responsiveFlg,
        changeFlg,
        confirmFlg,
        onClickOpenCalendarWindow,
        setPopupData
    } = props;

    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });

    // 以下仮設定定数
    const jikantaiList = [
        { text: "昼食", value: "1", checked: false },
        { text: "夕食", value: "2", checked: false },
    ];
    const allergyInfoList = [
        { text: "あり", value: "1", checked: false },
        { text: "なし", value: "2", checked: false },
        { text: "わからない", value: "0", checked: false }
    ];
    const representTelTypeList = [
        { text: "自宅", value: "1", checked: false },
        { text: "会社", value: "2", checked: false },
        { text: "携帯", value: "5", checked: false }
    ];
    const hopeCheckboxData = [
        { value: "希望する", id: true },
    ];
    const otherMailCheckbox = [
        { value: "上記アドレス以外に送付", id: true },
    ];
    const agreement = [
        { value: "同意する", id: "1" }
    ]

    const reserveExistence = [
        { text: "予約あり", value: "1", checked: false},
        { text: "予約なし", value: "0", checked: true}
    ]

    const history = useHistory();
    const store = useStore();
    const isCrawl = store.getState().login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;


    // モーダルオープン
    const openCal = (e) => {
        if (e != undefined) {
            if (e.target.id === 'reserveDate') {
                let riyoDate = restaurantReserveInfo.riyoDate ? commonUtil.getDateFromString(restaurantReserveInfo.riyoDate, "-") : new Date();
                let startDate = new Date(riyoDate);
                startDate.setDate(1);
                startDate.setDate(startDate.getDate() - startDate.getDay());
                let baseDate = new Date();
                baseDate.setDate(baseDate.getDate() + 3)
                if ((baseDate.getFullYear() === riyoDate.getFullYear() && baseDate.getMonth() === riyoDate.getMonth()) || baseDate >= startDate) {
                    startDate = new Date(baseDate);
                }
                const reqStartDate = commonUtil.getStringFromDate(startDate,"yyyy-MM-dd");

                onClickOpenCalendarWindow(reqStartDate);
            }
        }
    }

    // 予約時間一覧取得後処理
    const afterGetYoyakuKanoTimeInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setPopupData({
                yoyakuKanoTimeInfoList: data.yoyakuKanoTimeInfoList
            });
            onClickOpenPopupWindow("yoyakuTime");
        }
    }

    // 予約時間ポップアップ表示
    const onClickMealTime = () => {
        let reqCourseList = [];
        if (restaurantReserveInfo?.courseList?.length > 0) {
            reqCourseList = restaurantReserveInfo.courseList.map(course => {
                return { courseCd: course.courseCd }
            })
        }
        let req = {
            honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
            shisetsuCd: restaurantInfo.shisetsuCd,
            cornerBunKbn: "1",  /* 固定値 1:レストラン */
            rstEstheCd: restaurantInfo.restaurantCd,
            riyoDate: restaurantReserveInfo.riyoDate,
            riyoNinzu: restaurantReserveInfo.peopleNum,
            jikantai: restaurantReserveInfo.jikantai,
            importedFlg: true,
            courseList: reqCourseList
        }
        common.doPost(getYoyakuKanoTimeInfo, req, afterGetYoyakuKanoTimeInfo);
    }

    // 食事コース一覧取得後処理
    const afterGetCourseInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setPopupData({
                courseList: data.courseList
            });
        }
    }

    // 食事コースポップアップ表示
    const onClickCourse = () => {
        // コース情報取得
        let req = {
            honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
            shisetsuCd: restaurantInfo.shisetsuCd,
            cornerBunKbn: "1", /* 固定値 */
            rstEstheCd: restaurantInfo.restaurantCd,
            jikantai: restaurantReserveInfo.jikantai,
            riyoDate: restaurantReserveInfo.riyoDate,
        }
        common.doPost(getCourseInfo, req, afterGetCourseInfo);
        setPopupData({
            courseList: []
        });
        onClickOpenPopupWindow("course");
    }

    // プレー日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(restaurantReserveInfo.riyoDate);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();
        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    const dispCourse = (course) => {

        // Aコース：〇人, Bコース：〇人, Cコース：〇人, Dコー...
        return course.filter(item => item.courseNum && item.courseNum > 0).map(item => {
            return `${item.courseName}：${item.courseNum}人`
        }).join(", ");

    }

    const dispRyokin = (courseList) => {
        let ryokin = 0;
        if (courseList?.length > 0) {
            courseList.forEach(course => {
                ryokin += course.tanka * course.courseNum;
            })
        }
        return "合計：￥" + ryokin.toLocaleString();
    }

    const restaurant = <div >
        {confirmFlg ?
            <>
                <div className="importedInputWrapper">
                    <div className={"confirmContentsBorder"}>
                        <div className={"inputUserWrap"}>
                            <div className={responsiveFlg ? "confirmContentsBlock" : "confirmContents"}>
                                <Label
                                    label={"料金"}
                                    className="reserveInfoTitleNoWrap"
                                />
                                <div className={"confirmContentsBlock"}>
                                    <Label
                                        label={dispRyokin(restaurantReserveInfo.courseList)} //￥とカンマ区切り追加
                                        className="reserveInfoTitleNoWrap"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="reserveInputWrapper">
                    <div className={"reserveInfo"}>
                        <Label
                            label={"アレルギー"}
                            className="reserveInfoTitle"
                        />
                        <div className={"inputUserWrap"}>
                            <div className='confirmContentsBlock'>

                                <div className="confirmContents">
                                    <Label
                                        label={restaurantReserveInfo.allergyExistence == "1" ? "あり" : restaurantReserveInfo.allergyExistence == "2" ? "なし" : "わからない"}
                                        className="confirmContentLabel"
                                    />
                                </div>
                                <div className={restaurantReserveInfo.allergyBiko ? "confirmContents" : "hiddenItem"}>
                                    <Label
                                        label={"アレルギー内容"}
                                        className="confirmContentLabelGray"
                                    />
                                    <Label
                                        label={restaurantReserveInfo.allergyBiko}
                                        className="confirmContentLabel"
                                    />
                                </div>
                                <div className={restaurantReserveInfo.foodRequest ? "confirmContents" : "hiddenItem"}>
                                    <Label
                                        label="食事要望"
                                        className="confirmContentLabelGray"
                                    />
                                    <Label
                                        label={restaurantReserveInfo.foodRequest}
                                        className="confirmContentLabel"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <div className="userInput2">
                <div className={"stayInfo"} style={styles.userInput}>
                    <Label
                        label="時間帯"
                        className="popupLabel"
                    />
                    <RadioButtonForm
                        data={jikantaiList.map((jikantai) => {
                            if (jikantai.value == restaurantReserveInfo.jikantai) {
                                jikantai.checked = true;
                            } else {
                                jikantai.checked = false;
                            }
                            return jikantai;
                        })}
                        titleClassName="popupLabel"
                        labelClassName="inputRadioLabel"
                        inputClassName="inputRadioButtonGold"
                        wrapClassName={flgList.jikantai ? "errorClassCheck" : ""}
                        id="jikantaiRadio"
                        name="jikantaiRadio"
                        style={{ display: "flex", marginTop: "10px", marginBottom: "20px" }}
                        onChange={onChangeJikantai}
                    />
                    <ModalOptionForm
                        id={"reserveDate"}
                        divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                        title={"利用日"}
                        dateClass={(changeFlg || !restaurantReserveInfo.jikantai ? "disabledClass " : "") + (flgList.riyoDate ? "errorClass" : "")}
                        onClick={changeFlg || !restaurantReserveInfo.jikantai ? null : openCal}
                        text={restaurantReserveInfo.riyoDate ? getDateToString() : "選択する"}
                        labelClass={"dateLabel"}
                    />
                    <ModalOptionForm
                        id={"people"}
                        divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                        labelClassName="popupLabel"
                        dateClass={(restaurantReserveInfo.riyoDate ? "" : "disabledClass ") + (flgList.peopleNum ? "errorClass" : "")}
                        title={"利用人数"}
                        onClick={restaurantReserveInfo.riyoDate ? () => onClickOpenPopupWindow("people") : null}
                        text={restaurantReserveInfo.peopleNum ? restaurantReserveInfo.peopleNum + "人" : "選択する"}
                    />
                    <ModalOptionForm
                        id={"mealTime"}
                        divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                        labelClassName="popupLabel"
                        dateClass={(restaurantReserveInfo.peopleNum ? "" : "disabledClass ") + (flgList.yoyakuTime ? "errorClass" : "")}
                        title={"時間"}
                        onClick={restaurantReserveInfo.peopleNum ? () => onClickMealTime() : null}
                        text={restaurantReserveInfo.yoyakuTime ? commonUtil.getTimeStr(restaurantReserveInfo.yoyakuTime, "hh:mm") : "選択する"}
                    />
                    <ModalOptionForm
                        id={"course"}
                        divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                        labelClassName="popupLabel"
                        dateClass={(restaurantReserveInfo.yoyakuTime ? "" : "disabledClass ") + (flgList.courseList ? "errorClass" : "")}
                        title={"コース"}
                        onClick={restaurantReserveInfo.yoyakuTime ? () => onClickCourse() : null}
                        text={restaurantReserveInfo.courseList ? restaurantReserveInfo.courseList.length > 0 ? dispCourse(restaurantReserveInfo.courseList) : "選択する" : "選択する"}
                    />
                    {agreementList ? agreementList.map((doi, index) =>
                        <div key={"doi" + index} className={'agreementWrapper ' + (flgList.doi?.[index] ? "errorClassCheck" : "")}>
                            <div className='agreementTitleWrapper'>
                                <a className="confirmContentLink" onClick={() => onClickDoiTitle(index)}>{doi.title}</a>
                            </div>
                            <CheckboxListBoxGold
                                id={"agreement" + index}
                                name={"agreement"}
                                data={[{ ...agreement[0], checked: doi.checked }]}
                                onChange={() => onChangeAgreement(index)}
                                tabIndex=""
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        }
    </div>

    const userInfo = <div >
        {confirmFlg ?
            <>
                <div className="reserveInputWrapper lastContent">
                    <div className="userInput2">
                        <div className={"reserveInfo"}>
                            <div className={"inputUserWrap"}>
                                <div className="confirmContentsBorder firstContent">
                                    <Label
                                        label={"利用代表者"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={"氏名（カナ）"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={restaurantReserveInfo.daihyouNameKana}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                        <div className="confirmContents">
                                            <Label
                                                label={"氏名（漢字）"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={restaurantReserveInfo.daihyouName}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"利用代表者電話番号"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={restaurantReserveInfo.mainPhoneKbn == "1" ? "自宅" : restaurantReserveInfo.mainPhoneKbn == "2" ? "会社" : "携帯"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={restaurantReserveInfo.mainPhoneNumber}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"予約連絡先電話番号"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={restaurantReserveInfo.contactPhoneNumber}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"予約連絡先メールアドレス"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={restaurantReserveInfo.contactMailAddress}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"会員様とのご関係"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={restaurantReserveInfo.relation}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {restaurantReserveInfo.kozafurikaeDispFlg ?
                                    <div className="confirmContentsBorder">
                                        <Label
                                            label={"口座振替精算"}
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            <div className="confirmContents">
                                                <Label
                                                    label={restaurantReserveInfo.kozafurikaeFlg && hopeCheckboxData.find(value => value.id == restaurantReserveInfo.kozafurikaeFlg) ? hopeCheckboxData.find(value => value.id == restaurantReserveInfo.kozafurikaeFlg).value : "希望しない"}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"予約確認メール"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        {responsiveFlg ?
                                            <>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={restaurantReserveInfo.kakuninMailKiboKbn != 0 && restaurantReserveInfo.kakuninMailKiboKbn && hopeCheckboxData.find(value => value.id == restaurantReserveInfo.kakuninMailKiboKbn) ? hopeCheckboxData.find(value => value.id == restaurantReserveInfo.kakuninMailKiboKbn).value : "希望しない"}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                                <div className={restaurantReserveInfo.kakuninMailKiboKbn != 0 && restaurantReserveInfo.kakuninMailKiboKbn ? "confirmContentsBlock firstContent" : "hiddenItem"}>
                                                    <Label
                                                        label="メールアドレス"
                                                        className="confirmContentLabelGray"
                                                    />
                                                    <Label
                                                        label={restaurantReserveInfo.confirmReserveMail}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </>
                                            :
                                            <div className="confirmContents">
                                                <Label
                                                    label={restaurantReserveInfo.kakuninMailKiboKbn != 0 && restaurantReserveInfo.kakuninMailKiboKbn && hopeCheckboxData.find(value => value.id == restaurantReserveInfo.kakuninMailKiboKbn) ? hopeCheckboxData.find(value => value.id == restaurantReserveInfo.kakuninMailKiboKbn).value : "希望しない"}
                                                    className="confirmContentLabel"
                                                />
                                                <Label
                                                    label={restaurantReserveInfo ? restaurantReserveInfo.confirmReserveMail : ""}
                                                    className={restaurantReserveInfo.kakuninMailKiboKbn != 0 && restaurantReserveInfo.kakuninMailKiboKbn ? "confirmContentLabel" : "hiddenItem"}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <div style={{ paddingBottom: "30px" }}>
                <div className="representInfoLabel">
                    <Label
                        label={"アレルギー"}
                    />
                    <div className="importedFlex">
                        <Label
                            label={"食物アレルギー対応基本方針は"}
                            className="annotationMessage2"
                        />
                        <a href="https://www.resorttrust.co.jp/corporate/allergy/" className="annotationLink" target="_blank" rel="noopener noreferrer">こちら</a>
                    </div>
                </div>
                <RadioButtonForm
                    data={allergyInfoList.map((allergyInfo) => {
                        if (allergyInfo.value == restaurantReserveInfo.allergyExistence) {
                            allergyInfo.checked = true;
                        } else {
                            allergyInfo.checked = false;
                        }
                        return allergyInfo;
                    })}
                    labelClassName="inputRadioLabel"
                    inputClassName="inputRadioButtonGold"
                    wrapClassName={flgList.allergyExistence ? "errorClassCheck" : ""}
                    id="allergyExistence"
                    name="allergyExistence"
                    style={{ display: "flex", marginTop: "10px", marginBottom: "20px" }}
                    onChange={onChangeAllergyInfo}
                />
                <div className={"stayInfo"} style={styles.userInput}>
                    <LabelInputForm
                        label={"アレルギー内容"}
                        id="allergyBiko"
                        placeholder="甲殻類アレルギー"
                        disabled={!restaurantReserveInfo.allergyExistence || restaurantReserveInfo.allergyExistence != "1"}
                        value={restaurantReserveInfo ? restaurantReserveInfo.allergyBiko : ""}
                        onChange={() => handleRepresentInfo("allergyBiko")}
                        className={flgList.allergyBiko ? "inputKeywordError" : "inputKeyword"}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                        maxLength={"666"}
                    />
                    <Label
                        label={messageConst.ALLERGY_SAMPLE_MESSAGE}
                        className="annotationMessage"
                    />
                    <Label
                        label="食事要望"
                        className="popupLabel"
                    />
                    <TextArea
                        id="foodRequest"
                        style={flgList.foodRequest ? styles.foodRequestError : styles.foodRequest}
                        value={restaurantReserveInfo ? restaurantReserveInfo.foodRequest : ""}
                        onBlur={() => handleRepresentInfo("foodRequest")}
                        maxLength={"666"}
                    />
                </div>
                <Label
                    label={"利用代表者"}
                    className="representInfoLabel"
                />
                <LabelInputForm
                    label={"氏名（カナ）"}
                    type={"id"}
                    id="daihyouNameKana"
                    placeholder="ヤマダイチロウ"
                    className={flgList.daihyouNameKana ? "inputKeywordError" : "inputKeyword"}
                    value={restaurantReserveInfo ? restaurantReserveInfo.daihyouNameKana : ""}
                    onChange={() => handleRepresentInfo("daihyouNameKana")}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    maxLength={"35"}
                />
                <LabelInputForm
                    label={"氏名（漢字）"}
                    id="daihyouName"
                    placeholder="山田一郎"
                    className={flgList.daihyouName ? "inputKeywordError" : "inputKeyword"}
                    value={restaurantReserveInfo ? restaurantReserveInfo.daihyouName : ""}
                    onChange={() => handleRepresentInfo("daihyouName")}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    maxLength={"35"}
                />
                <Label
                    label="利用代表者電話番号"
                    className="popupLabel"
                    style={{ marginTop: "20px" }}
                />
                <RadioButtonForm
                    titleClassName="popupLabel"
                    labelClassName="inputRadioLabel"
                    inputClassName="inputRadioButtonGold"
                    wrapClassName={flgList.mainPhoneKbn ? "errorClassCheck" : ""}
                    data={restaurantReserveInfo && restaurantReserveInfo.mainPhoneKbn ?
                        representTelTypeList.map((telTypeInfo) => {
                            if (telTypeInfo.value == restaurantReserveInfo.mainPhoneKbn) {
                                telTypeInfo.checked = true;
                            } else {
                                telTypeInfo.checked = false;
                            }
                            return telTypeInfo;
                        })
                        : representTelTypeList}
                    id="mainPhoneKbn"
                    name="mainPhoneKbn"
                    style={{ display: "flex", marginTop: "10px", marginBottom: "20px" }}
                />
                <LabelInputForm
                    id="mainPhoneNumber"
                    placeholder="012-345-6789"
                    className={flgList.mainPhoneNumber ? "inputKeywordError" : "inputKeyword"}
                    onChange={() => handleRepresentInfo("mainPhoneNumber")}
                    value={restaurantReserveInfo ? restaurantReserveInfo.mainPhoneNumber : ""}
                    maxLength={"15"}
                />
                <LabelInputForm
                    label="予約連絡先電話番号"
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    id="contactPhoneNumber"
                    placeholder="012-345-6789"
                    className={flgList.contactPhoneNumber ? "inputKeywordError" : "inputKeyword"}
                    onChange={() => handleRepresentInfo("contactPhoneNumber")}
                    value={restaurantReserveInfo ? restaurantReserveInfo.contactPhoneNumber : ""}
                    maxLength={"15"}
                />
                <LabelInputForm
                    label={"予約連絡先メールアドレス"}
                    id="contactMailAddress"
                    placeholder="rtg@trast.jp"
                    className={flgList.contactMailAddress ? "inputKeywordError" : "inputKeyword"}
                    value={isCrawl ? crawlMember.mail_adr : restaurantReserveInfo ? restaurantReserveInfo.contactMailAddress : ""}
                    onChange={() => handleRepresentInfo("contactMailAddress")}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    disabled={isCrawl}
                    maxLength={"50"}
                />
                <Label
                    label="※弊社ドメイン「@resorttrust.co.jp」「@rt-group.jp」からのメールが受信できるよう設定確認をお願いします。"
                    className="annotationMessage"
                />
                <PullDownOptionForm
                    title={"会員様とのご関係"}
                    id="relation"
                    divClass="inputUserPullDownWrapLong"
                    labelClassName="popupLabel"
                    selectClass={"pullDownOptionStyle " + (flgList.relation ? "errorClass" : "")}
                    data={relationList}
                    onChange={() => onChangeRelation()}
                    state={restaurantReserveInfo ? restaurantReserveInfo.relationCd : ""}
                />
                {restaurantReserveInfo.relationCd != "" && serviceCheckInfo?.kozafurikaeKanoKbn && serviceCheckInfo.kozafurikaeKanoKbn == "1" ?
                    <>
                        <Label
                            label="口座振替精算"
                            className="popupLabel"
                        />
                        <div className='checkboxWrapper'>
                            <CheckboxListBoxGold
                                id={"kozafurikaeFlg"}
                                name={"kozafurikaeFlg"}
                                data={[{ ...hopeCheckboxData[0], checked: restaurantReserveInfo ? restaurantReserveInfo.kozafurikaeFlg : false }]}
                                onChange={() => onChangeCheckBox("kozafurikaeFlg")}
                                tabIndex=""
                            />
                            <a onClick={() => onClickServiceLink("口座振替精算", serviceCheckInfo.kozafurikaeKiyakuMongon)} className="confirmContentLink">口座振替精算とは</a>
                        </div>
                    </>
                    : null
                }
                <Label
                    label="予約確認メール"
                    className="popupLabel"
                />
                <CheckboxListBoxGold
                    id={"kakuninMailKiboKbn"}
                    title={"kakuninMailKiboKbn"}
                    name={"kakuninMailKiboKbn"}
                    data={[{ ...hopeCheckboxData[0], checked: restaurantReserveInfo && restaurantReserveInfo.kakuninMailKiboKbn != undefined ? restaurantReserveInfo.kakuninMailKiboKbn == "1" : true }]}
                    wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                    labelClassName="popupLabel"
                    onChange={() => onChangeCheckBox("kakuninMailKiboKbn")}
                    tabIndex=""
                />
                <Label
                    label={messageConst.RESERVE_MAIL_INFO_MESSAGE}
                    className="annotationMessage3"
                />
                {changeFlg ? null :
                    <CheckboxListBoxGold
                        id={"otherMailFlg"}
                        name={"otherMailFlg"}
                        data={[{ ...otherMailCheckbox[0], checked: restaurantReserveInfo && restaurantReserveInfo.otherMailFlg != undefined ? restaurantReserveInfo.otherMailFlg : false }]}
                        wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                        labelClassName="popupLabel"
                        onChange={() => onChangeCheckBox("otherMailFlg")}
                        tabIndex=""
                    />
                }
                <LabelInputForm
                    label={"メールアドレス"}
                    id="confirmReserveMail"
                    placeholder="rtg@trast.jp"
                    className={flgList.confirmReserveMail ? "inputKeywordError" : "inputKeyword"}
                    onChange={() => handleRepresentInfo("confirmReserveMail")}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap2"
                    value={changeFlg || (restaurantReserveInfo.otherMailFlg != undefined && restaurantReserveInfo.otherMailFlg) ? restaurantReserveInfo.confirmReserveMail : ""}
                    disabled={changeFlg ? restaurantReserveInfo.kakuninMailKiboKbn != undefined ? !restaurantReserveInfo.kakuninMailKiboKbn : false : restaurantReserveInfo && restaurantReserveInfo.otherMailFlg != undefined ? !restaurantReserveInfo.otherMailFlg : true}
                    maxLength={"50"}
                />
            </div>
        }
    </div>

    return (
        <>
            <div>{restaurant}</div>
            <div>{userInfo}</div>
        </>
    );
}

const styles = {
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    foodRequestError: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "100px",
        border: "solid 2px #ff0000",
        marginBottom: "30px",
        backgroundColor: "#ffdcdc",
    },
    foodRequest: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "100px",
        border: "solid 1px #b7b7b7",
        marginBottom: "30px",
    },
}
const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
    };
};
export default connect(mapStateToProps)(RestaurantInputList);